// Custom JS file for MrGuild
function updateProductLinks(root = document) {
    root.querySelectorAll('a[href*="/collections/"]').forEach(a => {
        const match = a.href.match(/\/products\/([^/?]+)/);
        if (match) {
            a.href = `/products/${match[1]}`;
        }
    });
}

document.addEventListener('DOMContentLoaded', function() {
    var element1 = document.getElementById('shopify-section-template--25570229584206__image_with_text_CtABbt');
    var element2 = document.getElementById('shopify-section-template--25446112592206__image_with_text_H6TAUy');

    if (typeof element1?.style !== 'undefined') {
        element1.style.cursor = 'pointer';
    }
    if (typeof element2?.style !== 'undefined') {
        element2.style.cursor = 'pointer';
    }

    document.addEventListener('click', element1, () => {
        window.location.href = '/pages/size-box';
    });

   document.addEventListener('click', element2, () => {
        window.location.href = '/pages/size-box';
    });

    updateProductLinks();
    const observer = new MutationObserver((mutations) => {
        mutations.forEach(mutation => {
            mutation.addedNodes.forEach(node => {
                if (node.nodeType === 1) { 
                    updateProductLinks(node);
                }
            });
        });
    });

    observer.observe(document.body, { childList: true, subtree: true });
});